import { Injector } from '@angular/core';
import {
  ActionButtonOutcomesType,
  ButtonActionType,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { ResetFormDataAction } from '../../../actions/form-submission.action';
import { functionCtaType } from '../cta-button-actions.utils';
import { handleRedirection } from '../cta-redirection.utils';
import { getOrganisationDataFromStoreAndCallUpdateMethod } from '../kyb-zone/kyb-zone-action.utils';
import { submitProfileZoneUserProfileChanges } from '../profile-zone/edit-user-profile.utils';
import { markAllNotificationsAsRead } from '../profile-zone/mark-all-notifications-as-read.utils';
import { toggleBiometricsAuthentication } from '../profile-zone/toggle-biometric-authentication.utils';
import { updateMarketingPreferences } from '../profile-zone/update-marketing-preferences.utils';

export const userProfileActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.SUBMIT_PROFILE_CHANGES_IN_PROFILE_ZONE,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      submitProfileZoneUserProfileChanges(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.CLEAR_FORM_STATE_AND_REDIRECT_TO_EDIT_PROFILE,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      const store = injector.get(Store);
      store.dispatch(new ResetFormDataAction());
      handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true, false);
    },
  ],
  [
    ButtonActionType.TOGGLE_BIOMETRIC_AUTHENTICATION,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      toggleBiometricsAuthentication(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.UPDATE_ORGANISATION,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      getOrganisationDataFromStoreAndCallUpdateMethod(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.MARK_ALL_NOTIFICATIONS_AS_READ,
    (injector: Injector) => {
      markAllNotificationsAsRead(injector);
    },
  ],
  [
    ButtonActionType.UPDATE_MARKETING_PREFERENCES,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      updateMarketingPreferences(injector, attri);
    },
  ],
]);
